module.exports = __webpack_public_path__ + "img/turntable-bg.d7d2b96a.svg";